import { render, staticRenderFns } from "./SendOrderList.vue?vue&type=template&id=586dd51c&scoped=true"
import script from "./SendOrderList.vue?vue&type=script&lang=js"
export * from "./SendOrderList.vue?vue&type=script&lang=js"
import style0 from "./SendOrderList.vue?vue&type=style&index=0&id=586dd51c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586dd51c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('586dd51c')) {
      api.createRecord('586dd51c', component.options)
    } else {
      api.reload('586dd51c', component.options)
    }
    module.hot.accept("./SendOrderList.vue?vue&type=template&id=586dd51c&scoped=true", function () {
      api.rerender('586dd51c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/pay/SendOrderList.vue"
export default component.exports